import(/* webpackMode: "eager" */ "/builds/equipmentshare/fleet/fleet-ui/apps/optimization/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/equipmentshare/fleet/fleet-ui/apps/optimization/src/app/MuiXLicense.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/equipmentshare/fleet/fleet-ui/apps/optimization/src/app/providers.tsx");
